import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import React, { useState } from 'react';
import { removeCoupons } from '../../data/data-service';
import Preloader from '../../../../../ui/svg/common/preloader';
import CartCoupon from '../../../../../ui/svg/shopping-cart/coupon';
import { getLocalData } from '../../domain/shopping-cart-address-provider';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';
import { getPeriodText } from '../../../../../domain/subscription/subscription-provider';


const CouponsList = () => {

    const dispatch = useAppDispatch();

    const [couponPreloader, setCouponPreloader] = useState('');
    const cartData = useAppSelector(store => store.root.cartData);
    const isSubscription = checkIsSubscription(cartData);
    const subscription = isSubscription ? (cartData.cartItems.find(cartItem => cartItem.isActive) ?? null) : null;

    /**
     * remove a coupon
     */
    const removeCouponHandler = async (originalCoupon: string) => {
        setCouponPreloader(originalCoupon);

        const response = await removeCoupons(
            [originalCoupon],
            getLocalData()
        );

        setCouponPreloader('')

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );
    };

    return (
        <div>
            {
                cartData.errorCoupons.map(coupon => {
                    return (
                        <div key={ coupon.originalCoupon } className="text-gray-700 border border-red rounded bg-red-100 px-3 py-2 flex flex-col start mt-4">
                            <div className="font-bold">{ coupon.originalCoupon }</div>
                            <div>{ coupon.message }</div>
                        </div>
                    )
                })
            }

            {
                cartData.redeemedCoupons.filter(coupon => !!coupon.message).map(coupon => {
                    return (
                        <div key={ coupon.originalCoupon } className="text-gray-700 border border-red rounded bg-red-100 px-3 py-2 flex flex-col start mt-4">
                            <div className="font-bold">{ coupon.originalCoupon }</div>
                            <div>{ coupon.message }</div>
                        </div>
                    )
                })
            }

            {
                cartData.redeemedCoupons.map(coupon => {

                    return (
                        <div key={ coupon.originalCoupon } className="text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex items-center mt-4">
                            <div className="text-green"><CartCoupon width="27" /></div>
                            <div className="flex flex-col mx-4 flex-1">
                                <div className="mb-1" data-qa="cart-applied-coupon-msg">
                                    <div>Coupon code applied:</div>
                                    <div>{ coupon.originalCoupon }</div>
                                </div>

                                {
                                    subscription && !!coupon.duration && coupon.duration > 0 &&
                                    <div className="text-xs text-gray-500 text-left">Valid for { coupon.duration } {
                                        getPeriodText(subscription.sbsPeriod ?? '', coupon.duration )
                                    }</div>
                                }

                                {
                                    couponPreloader !== coupon.originalCoupon &&
                                    <button
                                        type="button"
                                        className="text-xs text-gray-500 text-left underline"
                                        data-qa="cart-remove-coupon"
                                        onClick={ () => {
                                            removeCouponHandler(coupon.originalCoupon);
                                        }}>Remove</button>
                                }

                                { couponPreloader === coupon.originalCoupon && <Preloader width="15px" height="15px" color="#4f4f4f" /> }
                            </div>
                            <div className="text-green">
                                -<ProductPriceFormat price={ coupon.couponDiscount || 0 } />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
};

export default CouponsList;